import * as React from "react";
import { Component } from "react";
import styles from "../../../styles/flyouts/superadmin/boq_template_groups/Properties.scss";
import * as _ from "lodash";
import { withRouter } from "react-router";
import autobind from "autobind-decorator";
import {__, validateForm} from "../../../core/utils";
import { setNotification } from "../../../redux/actions/general/notification";
import { listBOQTemplateGroups, updateBOQTemplateGroup } from "../../../redux/actions/table/superadmin/boq_template_groups";
import EditBOQTemplateGroupForm from "../../../forms/superadmin/boq_template_groups/EditBOQTemplateGroupForm";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updateBOQTemplateGroup(formData.id, _.omit(formData, ['id'])).then(() => {
                listBOQTemplateGroups();

                this.props.readAction(formData.id);

                setNotification(__('properties.notifications.properties-have-been-saved'));
            })
        );
    }

    render() {
        const { data } = this.props;

        return (
            <div className={styles.scroller}>
                <EditBOQTemplateGroupForm
                    onSubmit={this._handleSubmit}
                    initialValues={{
                        ..._.pick(data, ['id', 'name']),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
